<template>
  <div>
    <ly-tab v-model="selectedId" :items="isRenderTab" v-if="isInit && isRenderTab.length > 0" :options="options"
            @change="change"></ly-tab>
    <div class="shengxiao_subTab_box" :class="getSubTabClass" v-if="generateShengxiaoPlayConfig.length > 0">
      <span :class="[{shengxiao_subTab_active: getSubTabActive(index + 1)}]"
            v-for="(item, index) in generateShengxiaoPlayConfig"
            :key="index"
            @click="onPlayShengxiao(index +1)"
      >{{item}}</span>
    </div>
    <ul class="putong_ul"
        :class="filterPlayClass('first', 'label')"
    >
      <li v-for="(item, index) in isRenderTopLabel('first')"
          :key="index"
          class="putong_item"
      >
        <span class="putong_item_label">{{item.label}}</span>
        <span class="putong_item_number" v-if="item.number">{{item.number}}</span>
        <span class="putong_item_rate">{{item.rate}}</span>
      </li>
    </ul>
    <ul class="list_ul" :class="filterPlayClass('first')">
      <TabSwiperListItem :item="item" :subId="subId" :selectedId="selectedId"
                         :shengxiaoData="shengxiaoData"
                         :selectedCount="selectedCount"
                         :nextLottery="nextLottery"
                         v-for="(item, i) in isRenderTopData"
                         :key="'kkb'+i"
                         ref="tabSwiperListItemRef"
                         @onSelected="onSelected(item)"

      />
    </ul>
    <ul class="putong_ul" v-if="isRenderBottomData.data && isRenderBottomData.data.length > 0"
        :class="filterPlayClass('second', 'label')"
    >
      <li v-for="(item, index) in isRenderTopLabel('second')"
          :key="index"
          class="putong_item"
      >
        <span class="putong_item_label">{{item.label}}</span>
        <span class="putong_item_number" v-if="item.number">{{item.number}}</span>
        <span class="putong_item_rate">{{item.rate}}</span>
      </li>
    </ul>
    <ul class="list_ul list_ul_bottom" v-if="isRenderBottomData.data && isRenderBottomData.data.length > 0"
        :class="filterPlayClass('second')"
    >
      <TabSwiperListItem :item="item" :subId="subId" :selectedId="selectedId"
                         :shengxiaoData="shengxiaoData"
                         :selectedCount="selectedCount"
                         :nextLottery="nextLottery"
                         v-for="(item, i) in isRenderBottomData.data"
                         :key="'kkb'+i"
                         ref="tabSwiperListItemRef"
                         @onSelected="onSelected(item)"
      />
    </ul>
    <ul class="putong_ul" v-if="isRenderBottom2Data.data && isRenderBottom2Data.data.length > 0"
        :class="filterPlayClass('second', 'label')"
    >
      <li v-for="(item, index) in isRenderTopLabel('third')"
          :key="index"
          class="putong_item"
      >
        <span class="putong_item_label">{{item.label}}</span>
        <span class="putong_item_number" v-if="item.number">{{item.number}}</span>
        <span class="putong_item_rate">{{item.rate}}</span>
      </li>
    </ul>
    <ul class="list_ul" v-if="isRenderBottom2Data.data && isRenderBottom2Data.data.length > 0"
        :class="filterPlayClass('second')"
    >
      <TabSwiperListItem :item="item" :subId="subId" :selectedId="selectedId"
                         :shengxiaoData="shengxiaoData"
                         :selectedCount="selectedCount"
                         :nextLottery="nextLottery"
                         v-for="(item, i) in isRenderBottom2Data.data"
                         :key="'kkb'+i"
                         ref="tabSwiperListItemRef"
                         @onSelected="onSelected(item)"
      />
    </ul>
  </div>
</template>
<script>
  import Vue from "../../../../../utils/bus"
  import { filterNumber } from "../../../../../utils/lhMethods";
  import { getTabItem, LH_SUB_TAB_CONFIG } from "../../../../../utils/lhConfig";
  import objectPath from 'object-path';
  import TabSwiperListItem from "./list-item";
  import { mapActions, mapState } from "vuex";

  export default {
    name: "tab-swiper-lh",
    components: {TabSwiperListItem},
    props: {
      data: {
        type: Array,
        default() {
          return [];
        }
      },
      subId: Number,
      supId: Number,
      category_id: Number,
      shengxiaoData: Array,
      nextLottery: {
        type: Object,
        default: null
      },
    },
    data() {
      return {
        rate: 1,
        selectedId: 0, // 子玩法，下标0开始
        selectedCount: {},
        options: {
          activeColor: "#1d98bd"
          // 可在这里指定labelKey为你数据里文字对应的字段
        },
        isInit: true, // 页面初始化
      };
    },
    methods: {
      ...mapActions("root", ["setSelectedDantuoData", "setSelectedShengxiaoPlayRadio"]),
      // 重置所有数据
      resetData() {
        this.selectedCount = {};
        this.setSelectedShengxiaoPlayRadio(1);
        this.setSelectedDantuoData({});
        // 清空数据
        this.$emit("selectedlm", {selectedCount: {}});
        // 还原胆拖图片
        this.$refs.tabSwiperListItemRef.forEach(tabSwiper => {
          tabSwiper.isDantuoImg = false
        });
      },
      resetRender() {
        this.isInit = false;
        this.selectedId = 0;
        setTimeout(() => {
          this.isInit = true;
        }, 10);
      },
      // item点击
      onSelected(item) {
        const isActive = this.selectedCount[item.id];
        let newSelectedCount = item;
        if (isActive) {
          newSelectedCount = false;
        }
        this.selectedCount = {
          ...this.selectedCount,
          [item.id]: newSelectedCount
        };
        this.$emit("selectedlm", {
          selectedCount: this.selectedCount,
          selectedId: this.selectedId,
        });
      },
      // 子玩法change事件，所有data还原
      change(item, index) {
        this.resetData();
        this.$emit("getItem", this.supId, this.subId, this.lottery_type, item.label);
      },
      // 校验号码背景图片
      filterNumberColor(number) {
        const isFilterNumber = filterNumber(number);
        if (isFilterNumber) {
          return isFilterNumber;
        }
        return 'number_shengxiao';
      },

      // 更改生肖玩法index
      onPlayShengxiao(index) {
        this.resetData();
        this.setSelectedShengxiaoPlayRadio(index);
      }
    },
    created() {
      Vue.$on("reseTabSwiper", () => {
        this.selectedCount = {};
      })
    },
    watch: {
      // 监控子菜单，重置tab
      isRenderTab() {
        this.resetRender();
      }
    },
    computed: {
      ...mapState({
        selectedShengxiaoPlayRadio: state => state.root.selectedShengxiaoPlayRadio
      }),
      // 根据类型渲染tab
      isRenderTab() {
        let DEFAULT_TAB = [];
        // 这个tab是写死的
        getTabItem(this.subId).forEach(item => DEFAULT_TAB.push({label: item}));
        return DEFAULT_TAB;
      },
      // 根据玩法，渲染不同的列表配置 上面部分，这里是渲染控制中心
      isRenderTopData() {
        let DEFAULT_DATA = this.data;
        // 正特
        if (this.subId === 1) {
          DEFAULT_DATA = [this.data[0], this.data[1]];
        }
        // 正码 add
        if (this.subId === 2) {
          DEFAULT_DATA = [this.data[0], this.data[1]];
        }
        // 如果是正特，直接返回截取字段
        if (this.subId === 3) {
          const ZHENGTE_DATA = JSON.parse(JSON.stringify(DEFAULT_DATA[this.selectedId]));
          return ZHENGTE_DATA.data.splice(0, 49);
        }
        // 特肖首位
        if (this.subId === 4) {
          DEFAULT_DATA = [this.data[0]];
        }
        // 连码玩法 肖尾混合对碰
        if (this.subId === 8 &&
          (this.selectedId === 3 || this.selectedId === 4 || this.selectedId === 5 || this.selectedId === 6)
        ) {
          // 混合对碰，拆分数据
          if (this.selectedShengxiaoPlayRadio === 5) {
            const shengxiaoListData = objectPath.get(this.data, `${this.selectedId}.data.${this.selectedShengxiaoPlayRadio}.0`) || [];
            return shengxiaoListData;
          }
          // 默认返回
          const shengxiaoListData = objectPath.get(this.data, `${this.selectedId}.data.${this.selectedShengxiaoPlayRadio}`);
          return shengxiaoListData;
        }
        return objectPath.get(DEFAULT_DATA, `${this.selectedId}.data`) || [];
      },
      // 根据玩法，渲染不同的列表配置 下面部分，这里是渲染控制中心
      isRenderBottomData() {
        // 特码
        let DEFAULT_DATA = {data: []};
        if (this.subId === 1) {
          DEFAULT_DATA = this.data[2];
        }
        // 正码 add
        if (this.subId === 2) {
          DEFAULT_DATA = this.data[2];
        }
        // 正特
        if (this.subId === 2) {
          //DEFAULT_DATA = this.data[1];
        }
        // 单独拆分正特数据
        if (this.subId === 3) {
          const ZHENGTE_DATA = JSON.parse(JSON.stringify(this.data[this.selectedId]));
          DEFAULT_DATA.data = ZHENGTE_DATA.data.splice(49, 67);
        }
        // 特肖首位
        if (this.subId === 4) {
          DEFAULT_DATA = this.data[1];
        }
        // 连码玩法 肖尾混合对碰
        if (this.subId === 8 &&
          (this.selectedId === 3 || this.selectedId === 4 || this.selectedId === 5 || this.selectedId === 6)
          && this.selectedShengxiaoPlayRadio === 5
        ) {
          const shengxiaoListData = objectPath.get(this.data, `${this.selectedId}.data.${this.selectedShengxiaoPlayRadio}.1`);
          DEFAULT_DATA = {
            data: shengxiaoListData
          }
        }
        return DEFAULT_DATA;
      },
      // 渲染第三组list，设计到的玩法很少
      isRenderBottom2Data() {
        // 特码
        let DEFAULT_DATA = {data: []};
        // 特肖首位
        if (this.subId === 4) {
          DEFAULT_DATA = this.data[2];
        }
        return DEFAULT_DATA;
      },
      // 根据不同的玩法，返回对应的label
      isRenderTopLabel() {
        return (type) => {
          const INIT_LABEL = {
            a: {label: '号码', rate: '赔率'},
            b: {label: '生肖', number: '号码', rate: '赔率'},
            c: {label: '尾数', rate: '赔率'},
            d: {label: '头数', rate: '赔率'},
            e: {label: '生肖', rate: '赔率'},
            f: {label: '类别', number: '号码', rate: '赔率'}
          };
          let DEFAULT_LABEL = Array.from(Array(5), () => INIT_LABEL.a);
          // 根据type来区分几排，this.subId玩法 this.selectedId子玩法
          if (type === 'first') {
            if (this.subId === 4 || (this.subId === 5) || this.subId === 6 || this.subId === 7 || this.subId === 11 ||
              (this.subId === 8 && this.selectedShengxiaoPlayRadio === 3 && (this.selectedId === 3 || this.selectedId === 4 || this.selectedId === 5 || this.selectedId === 6))
            ) {
              DEFAULT_LABEL = Array.from(Array(1), () => INIT_LABEL.b);
            }
          }

          const isSecond = type === 'second' && (this.subId === 4);
          if (isSecond ||
            (this.subId === 5 && (this.selectedId === 2 || this.selectedId === 3)) ||
            (this.subId === 8 && this.selectedShengxiaoPlayRadio === 4 && (this.selectedId === 3 || this.selectedId === 4 || this.selectedId === 5 || this.selectedId === 6))
          ) {
            DEFAULT_LABEL = Array.from(Array(2), () => INIT_LABEL.c);
          }

          const isThird = type === 'third' && (this.subId === 4);
          if (
            isThird
          ) {
            DEFAULT_LABEL = Array.from(Array(2), () => INIT_LABEL.d);
          }
          // 总肖
          if (this.subId === 10) {
            DEFAULT_LABEL = Array.from(Array(2), () => INIT_LABEL.e);
          }
          // 半波  五行
          if (this.subId === 14 || this.subId === 15 ||
            (this.subId === 8 && (this.selectedShengxiaoPlayRadio === 3 || this.selectedShengxiaoPlayRadio === 4 || this.selectedShengxiaoPlayRadio === 5) && (this.selectedId === 3 || this.selectedId === 4 || this.selectedId === 5 || this.selectedId === 6))
          ) {
            DEFAULT_LABEL = Array.from(Array(1), () => INIT_LABEL.f);
          }
          return DEFAULT_LABEL;
        }
      },
      // 根据不同的玩法 返回样式
      filterPlayClass() {
        // type表示第几排，label表示是表头
        return (type, label) => {
          let DEFAULT_CLASS = '';
          // first 是第一排，this.subId是当前玩法,this.selectedId为 这个玩法的子玩法
          const isFirst = type === 'first' && (this.subId === 4 || (this.subId === 5) || this.subId === 6 || this.subId === 7 || this.subId === 14 || this.subId === 15 || this.subId === 11);
          // 生肖 或者肖尾数
          if (isFirst ||
            (this.subId === 8 && (this.selectedShengxiaoPlayRadio === 3 || this.selectedShengxiaoPlayRadio === 4 || this.selectedShengxiaoPlayRadio === 5) && (this.selectedId === 3 || this.selectedId === 4 || this.selectedId === 5 || this.selectedId === 6))
          ) {
            DEFAULT_CLASS = 'ul_shengxiao_first';
          }
          const isSecond = type === 'second' && (this.subId === 4);
          if (isSecond ||
            (this.subId === 5 && (this.selectedId === 2 || this.selectedId === 3) || this.subId === 10)
          ) {
            DEFAULT_CLASS = 'ul_shengxiao_secord';
          }
          // 由于是垂直布局，需要固定高度，每个玩法的高度又不一样
          if (!label && type === 'first' &&
            (this.subId === 1 || this.subId === 2 || this.subId === 3 || this.subId === 8 || this.subId === 9 || this.subId === 12 || this.subId === 13)
          ) {
            DEFAULT_CLASS += ' ul_10';
          }
          return DEFAULT_CLASS;
        }
      },
      // 根据生肖玩法，返回sub菜单配置
      generateShengxiaoPlayConfig() {
        const INIT_CONFIG = {
          a: ['单注/复式', '胆拖'],
          b: ['单注/复式', '胆拖', '生肖对碰', '尾数对碰', '混合对碰'],
        };
        let DEFAULT_CONFIG = [];
        if (
          this.subId === 6 || this.subId === 7 ||
          (this.subId === 8 && this.selectedId === 0 || this.subId === 8 && this.selectedId === 1 || this.subId === 8 && this.selectedId === 2)
        ) {
          DEFAULT_CONFIG = INIT_CONFIG.a;
        }
        if (
          (this.subId === 8 && this.selectedId === 3) || (this.subId === 8 && this.selectedId === 4) || (this.subId === 8 && this.selectedId === 5) || (this.subId === 8 && this.selectedId === 6)
        ) {
          DEFAULT_CONFIG = INIT_CONFIG.b;
        }
        return DEFAULT_CONFIG;
      },
      // 获取不同的样式
      getSubTabClass() {
        let DEFAULT_CLASS = '';
        if (
          (this.subId === 8 && this.selectedId === 3) || (this.subId === 8 && this.selectedId === 4) || (this.subId === 8 && this.selectedId === 5) || (this.subId === 8 && this.selectedId === 6)
        ) {
          DEFAULT_CLASS = 'shengxiao_subTab_lianma';
        }
        return DEFAULT_CLASS;
      },
      // 获取生肖sub菜单是否激活
      getSubTabActive() {
        return (index) => {
          return this.selectedShengxiaoPlayRadio === index;
        }
      },
    },
  };
</script>
<style lang="less" scoped>
  .title {
    font-size: 3vw;
    margin: 20px;
  }

  // 普通表头
  .putong_ul {
    display: flex;
    margin-top: 10px;

    li {
      width: 33%;
      padding: 15px 0;
      text-align: center;
      color: #060645;
      background-color: #fff7db;
      border: 0.5px solid #EEE;

      span {
        font-size: 30px;
      }
    }
  }

  .list_ul {
    display: flex;
    flex-wrap: wrap;
    padding: 0 1px;
  }

  // 生肖 top 的label的样式
  .ul_shengxiao_first {
    li {
      width: 100%;

      .list_ul_li_shengxiao {
        display: flex;
        max-width: 550px;
      }
    }

    .putong_item {
      width: 100%;
      text-align: left;

      span {
        display: inline-block;
        text-align: center;
      }

      .putong_item_label {
        width: 120px;
      }

      .putong_item_number {
        width: 480px;
      }

      .putong_item_rate {
        width: 80px;
      }
    }
  }

  // 生肖 第二部分 label样式
  .ul_shengxiao_secord {
    .list_ul_li {
      padding: 0 20px;
      width: 50%;

      .number {
        width: 35%;
      }

      .list_ul_li_state {
        width: 28%;
      }
    }

    .putong_item {
      width: 50%;

      span {
        width: 48%;
        display: inline-block;
        text-align: center;
      }
    }
  }


  // 生肖玩法
  .shengxiao_subTab_box {
    margin: 10px 20px;
    height: 70px;
    background: #fff;
    border: 1px solid #d6d6d6;

    span {
      display: inline-block;
      width: 50%;
      height: 70px;
      line-height: 70px;
      font-size: 30px;
      text-align: center;
    }

    // active
    .shengxiao_subTab_active {
      background: #f71c1c;
      color: #fff;
    }
  }

  // 连码
  .shengxiao_subTab_lianma {
    span {
      width: 20%;
    }
  }

  .ul_10 {
    flex-direction: column;
    height: 750px;
  }
  .ul_shengxiao_first.ul_10 {
    flex-direction: column;
    height: 120vw;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/hall/components/tab-swiper-lh/index.vue